import { DataGrid as MUIDataGrid } from '@mui/x-data-grid';
import { type DataGridProps, DataGrid as PantryDataGrid } from '@side/pantry';

export function DataGrid(props: Omit<DataGridProps, 'MUIDataGrid'>) {
  return <PantryDataGrid MUIDataGrid={MUIDataGrid} {...props} />;
}
